
import { useTimeAwareBackground } from './useTimeAwareBackground';

// Export the time-aware background hook as the main background hook
export const useUnsplashBackground = () => {
  return useTimeAwareBackground();
};
